export function getContrastColorYIQ(colorInHexString) {
  let color = colorInHexString.replace('#', '');

  var r = parseInt(color.substr(0,2),16);
  var g = parseInt(color.substr(2,2),16);
  var b = parseInt(color.substr(4,2),16);
  var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

  return (yiq >= 128) ? 'black' : 'white';
}

export function changeBrightness(colorInHexString, amt) {
  var usePound = false;
  var newColor = colorInHexString;

  if (colorInHexString[0] === '#') {
    newColor = colorInHexString.slice(1);
    usePound = true;
  }

  var num = parseInt(newColor,16);

  var r = (num >> 16) + amt;

  if (r > 255) {r = 255;}
  else if (r < 0) {r = 0;}

  var b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) {b = 255;}
  else if (b < 0) {b = 0;}

  var g = (num & 0x0000FF) + amt;

  if (g > 255) {g = 255;}
  else if (g < 0) {g = 0;}

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);

}



// WEBPACK FOOTER //
// ./src/helper/color-helper.js